import { useState } from "react";
import { manufacturerServices } from "../../data/home";
import { Icon } from "../ui/Icon";
import { EnquiryDialog } from "../contact/EnquiryDialog";

export function ManufacturerSection() {
  const [open, setOpen] = useState(false);
  return <>
    <section id="manufacturers" className="container manufacturer-section" aria-labelledby="manufacturers-heading">
      <div className="manufacturer-copy">
        <p className="section-kicker">For Iranian Manufacturers</p>
        <h2 id="manufacturers-heading">Looking to expand your export reach?</h2>
        <p>IranTradeReach works with selected Iranian producers to identify relevant foreign markets and qualified buyers.</p>
        <button className="button button--outline" type="button" onClick={() => setOpen(true)}>Discuss Export Development</button>
        <a className="manufacturer-email" href="mailto:partners@irantradereach.ir">partners@irantradereach.ir</a>
      </div>
      <ul className="manufacturer-capabilities">{manufacturerServices.map((service) => <li key={service}><span><Icon name="check" size={13} strokeWidth={3} /></span>{service}</li>)}</ul>
    </section>
    <EnquiryDialog open={open} onClose={() => setOpen(false)} kind="partnership" title="Tell us about your manufacturing business." />
  </>;
}
